// Port of api/fuel/app/classes/filter/core/package.php
// JS note:
// - folder routing in this file is JS-only bootstrap glue for the offline runtime
// - package payload ownership should still live in the type/entity/unit files that mirror PHP
import F from 'offline/filter/constants'

var Package = {
	run: function(config, filter, data) {
		var global = {
			ownerType: config.ownerType,
			owner: config.owner,
			userID: config.userID,
			sessionID: config.sessionID,
			ownerID: config.owner ? (config.owner.get_id ? config.owner.get_id() : config.owner.id) : 0,
			filterType: config.filterType,
			resultType: config.resultType,
			resultIndex: data.results || [],
			userIndex: data.users || [],
			referenceIndex: data.reference || data.results || [],
			nestedIndex: {},
			nestedGameIndex: {},
			filter: filter,
			settings: config.settings || {},
			context: data.context || {},
			can: config.can || {},
			config: config,
			// Shared data populated by prepare phases
			games: {},
			owners: {},
			ratings: {},
			plays: {},
			gamePlays: {},
			tags: { game: {}, item: {} },
			versions: {},
			nested: {},
			_shared: {}
		}

		var folder = F.TYPE_FOLDER[config.filterType]
		if (folder === 'games') {
			var GamesPackage = require('offline/filter/package/games').default
			return GamesPackage.run(config, filter, data, global)
		}
		if (folder === 'users') {
			var UsersPackage = require('offline/filter/package/users').default
			return UsersPackage.run(config, filter, data, global)
		}
		if (folder === 'lists') {
			var ListsPackage = require('offline/filter/package/lists').default
			return ListsPackage.run(config, filter, data, global)
		}

		// Fallback for unimplemented types
		return [[], { nested: {} }]
	}
}

export default Package
